module.exports = __webpack_public_path__ + "static/personalBg.e3b5eda4.jpg";